import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";
import BookConsultant from "../services/service-book-consultant/bookconsultant";

// const Banner = dynamic(() => import("./banner-contact/banner"), { ssr: true });
import Banner from "./banner-contact/banner";
const CaseStudies = dynamic(() => import("./case-studies/case-studies"), { ssr: true });
const BookSection = dynamic(() => import("./book-section/book-section"), { ssr: true });
const ProjectOverView = dynamic(() => import("./project-overview/project-overview"), { ssr: true });
const RelatedCaseStudies = dynamic(() => import("./related-case-studies/related-case-studies"), { ssr: true });

const CaseNew = (props) => {
	const blocks = props?.data?.blocks;

	const [newBlock, setNewBlock] = useState([]);

	useEffect(() => {
		const relevantComponents = [
			"blocks.case-study-key-points",
			"blocks.key-points",
			"blocks.stack-holder",
			"blocks.casestudy-overview",
			"blocks.technology-tech-stack",
		];

		const filteredBlocks = blocks?.filter((element) => {
			return relevantComponents.includes(element.__component);
		});
		const finalBlock = blocks?.filter((element) => {
			return !relevantComponents.includes(element.__component);
		});

		const ProjectOverView = {
			__component: "blocks.case-study-key-points",
			keyPoints: filteredBlocks,
		};
		finalBlock?.splice(1, 0, ProjectOverView);

		setNewBlock(finalBlock);
	}, [blocks]);

	return (
		<div className="book-new-main">
			<Banner data={props?.data} />
			{newBlock?.length > 0 &&
				newBlock.map((block, i) => {
					return (
						<React.Fragment key={i}>
							{block.__component === "blocks.about-client" && (
								<CaseStudies data={props?.data} block={block} />
							)}
							{block.__component === "blocks.case-study-key-points" && (
								<ProjectOverView data={block} />
							)}
							{block.__component === "blocks.related-case-studies" && (
								<RelatedCaseStudies data={block} />
							)}
							{block.__component === "blocks.book-consultations" && (
								<BookSection data={block} />
							)}
							{block.__component === "blocks.cta" && (
								<BookConsultant block={block} />
							)}
						</React.Fragment>
					);
				})}
		</div>
	);
};

export default CaseNew;
